import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgTikTok = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                d: "M12.0383 1.01833C13.2392 1 14.4308 1.00917 15.6225 1C15.6958 2.4025 16.2 3.8325 17.2267 4.8225C18.2533 5.84 19.7017 6.3075 21.1133 6.46333V10.1575C19.7933 10.1117 18.4642 9.83667 17.2633 9.26833C16.7408 9.03 16.255 8.7275 15.7783 8.41583C15.7692 11.0925 15.7875 13.7692 15.76 16.4367C15.6867 17.72 15.265 18.9942 14.5225 20.0483C13.3217 21.8083 11.2408 22.9542 9.10499 22.9908C7.79416 23.0642 6.48333 22.7067 5.36499 22.0467C3.51333 20.9558 2.21166 18.9575 2.01916 16.8125C2.00083 16.3542 1.99166 15.8958 2.00999 15.4467C2.17499 13.705 3.03666 12.0367 4.37499 10.9C5.89666 9.58 8.02333 8.9475 10.0125 9.32333C10.0308 10.68 9.97583 12.0367 9.97583 13.3933C9.06833 13.1 8.00499 13.1825 7.20749 13.7325C6.62999 14.1083 6.18999 14.6858 5.96083 15.3367C5.76833 15.8042 5.82333 16.3175 5.83249 16.8125C6.05249 18.3158 7.50083 19.5808 9.04083 19.4433C10.0675 19.4342 11.0483 18.8383 11.58 17.9675C11.7542 17.665 11.9467 17.3533 11.9558 16.9958C12.0475 15.355 12.0108 13.7233 12.02 12.0825C12.0292 8.38833 12.0108 4.70333 12.0383 1.01833Z",
                fill: "currentColor"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgTikTok);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const TikTok = Memo;
export { TikTok as default };
